'use strict';

global.rangy = require('rangy');
global.rangy = require('rangy/lib/rangy-selectionsaverestore');
global.numeral = require('numeral');

require('angular');
require('angular-ui-router');
require('nginflection');
require('ui-select');
require('angular-translate');

require('angular-numeraljs');
require('angular-ui-bootstrap/dist/ui-bootstrap-tpls');
require('ng-file-upload');

global._ = require('lodash');
//# sourceMappingURL=vendors.js.map


// WEBPACK FOOTER //
// ./~/ng-admin/lib/javascripts/vendors.js